import React from 'react';
import { Button } from 'ui';
import Image from '~/components/Image';
import GiftCardLink from '~/components/Links/GiftCardLink';
import { FT_GIFT_CARD_PURCHASE_ENABLED } from '../../constants/featureToggles';
import METALLIC_CARD from './images/metallic_card.png';

const copy = [
  {
    label: 'Easy gifts for any budget.',
    content:
      'Gift cards start at $25, and can easily be applied to any purchase on SidelineSwap.',
  },
  {
    label: 'Delivered via email.',
    content:
      'Instructions and a redemption code for your gift card will be sent to you via email.',
  },
  {
    label: 'Activate from anywhere.',
    content: (
      <span>
        Gift cards can be activated by visiting{' '}
        <GiftCardLink className="text-blue-500 underline">
          sidelineswap.com/gift-cards
        </GiftCardLink>
        . The balance will be immediately added to your account and available
        for use.
      </span>
    ),
  },
  {
    label: 'No expiration date.',
    content: 'Once redeemed, gift card credit never expires.',
  },
];

interface Props {}

const GiftCardHighlights: React.FC<Props> = () => (
  <div className="mb-6 flex flex-col md:mb-12 md:flex-row">
    <div className="md:w-1/2">
      <Image src={METALLIC_CARD} className="mx-auto block lg:w-4/6" />
    </div>

    <div className="mx-auto" />

    <div className="space-y-4 text-center md:w-1/2 md:text-left">
      {copy.map(c => (
        <div key={c.label}>
          <b className="block md:inline-block">{c.label}</b> {c.content}
        </div>
      ))}

      {FT_GIFT_CARD_PURCHASE_ENABLED && (
        <GiftCardLink page="purchase">
          <Button color="turf-green" className="mt-6">
            Buy Gift Card
          </Button>
        </GiftCardLink>
      )}
    </div>
  </div>
);

export default GiftCardHighlights;
